/* FalcX guides (r7): guides hub filter, "Parts for your Falcon", product strips, and the article extras (contents
   list, phone-friendly tables, related products for the vehicle on show).
   Reads window.FalcxVehicle (falcx-finder.js) and window.FalcxFitment (falcx-fitment.js); edits neither.
   The pure functions at the top are exported for tests/falcx-guides.test.cjs. */
(function () {
  'use strict';
  /* Guide filter groups (article tags series:<group>) and the finder series each one covers. */
  var GROUPS = { 'ea-el': ['ea-ed', 'ef-el'], au: ['au'], 'ba-bf': ['ba-bf'], 'fg-fgx': ['fg', 'fgx'] };
  var LABELS = { 'ea-el': 'EA–EL', au: 'AU', 'ba-bf': 'BA–BF', 'fg-fgx': 'FG–FGX' };
  function list(value) {
    if (Array.isArray(value)) return value.filter(function (x) { return typeof x === 'string' && x.trim(); }).map(function (x) { return x.trim(); });
    if (typeof value === 'string') return value.split(',').map(function (x) { return x.trim(); }).filter(Boolean);
    return [];
  }
  /* Finder series ("fgx", "ea-ed") -> guide group ("fg-fgx", "ea-el"). Also accepts a group or the finder's
     grouped spellings. Unknown -> ''. */
  function groupOf(series) {
    if (!series) return '';
    if (GROUPS[series]) return series;
    for (var g in GROUPS) if (GROUPS[g].indexOf(series) !== -1) return g;
    return '';
  }
  /* Fitment key ("BA–BF Ute", "FG X Sedan", "EA–EL Sedan") -> guide group. */
  function groupOfKey(key) {
    var k = String(key || '').trim().toUpperCase();
    if (/^(EA|EB|ED|EF|EL)[–-]/.test(k)) return 'ea-el';
    if (/^AU\b/.test(k)) return 'au';
    if (/^BA[–-]BF\b|^BA\b|^BF\b/.test(k)) return 'ba-bf';
    if (/^FG\b|^FG[–-]|^FGX\b/.test(k)) return 'fg-fgx';
    return '';
  }
  /* A guide with no series tags is for every Falcon. */
  function articleInGroup(articleSeries, group) {
    var own = list(articleSeries);
    return !group || !own.length || own.indexOf(group) !== -1;
  }
  function vehicleKeys(product) {
    var keys = list(product && product.vehicles);
    ((product && product.variants) || []).forEach(function (v) { keys = keys.concat(list(v && v.vehicles)); });
    return keys;
  }
  /* Product card data (falcx-fitment-data) against a guide group. A vehicle list decides; without one, series tags
     decide; with neither (nothing known) the product stays. */
  function productInGroup(product, group) {
    if (!group) return true;
    var keys = vehicleKeys(product);
    if (keys.length) return keys.some(function (k) { return groupOfKey(k) === group; });
    var series = list(product && product.series);
    if (series.length) return series.some(function (s) { return GROUPS[group].indexOf(s) !== -1; });
    return true;
  }
  /* Where a product sits in "Parts for your Falcon": 0 fits, 1 some options fit, 2 its series tags include the
     vehicle's series (no vehicle list yet: the card itself still says "Fitment not listed yet"), null = leave out
     (not listed for it, excluded by body tags, or nothing known). summarize = FalcxFitment.summarize. */
  function vehicleRank(product, vehicle, summarize, bodies) {
    if (!vehicle) return null;
    var body = list(bodies);
    if (body.length && vehicle.body && body.indexOf(vehicle.body) === -1) return null;
    var state = summarize ? summarize(product, vehicle) : 'unknown';
    if (state === 'match') return 0;
    if (state === 'options') return 1;
    if (state === 'unknown' && list(product && product.series).indexOf(vehicle.series) !== -1) return 2;
    return null;
  }
  /* items: [{rank (null = hidden), index}] -> indexes to show, best rank first, original order within a rank. */
  function pick(items, limit) {
    return items.filter(function (i) { return i.rank !== null && i.rank !== undefined; })
      .sort(function (a, b) { return a.rank - b.rank || a.index - b.index; })
      .slice(0, limit > 0 ? limit : Infinity)
      .map(function (i) { return i.index; });
  }
  function slug(text, taken) {
    var base = String(text || '').toLowerCase().replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'section';
    var id = base, n = 2;
    while (taken && taken[id]) id = base + '-' + n++;
    if (taken) taken[id] = true;
    return id;
  }
  var core = { GROUPS: GROUPS, LABELS: LABELS, groupOf: groupOf, groupOfKey: groupOfKey, articleInGroup: articleInGroup, productInGroup: productInGroup, vehicleRank: vehicleRank, pick: pick, slug: slug };
  if (typeof module !== 'undefined' && module.exports) module.exports = core;
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (window.FalcxGuides) { window.FalcxGuides.init(); return; }

  function parse(el) { try { return JSON.parse(el.dataset.fitment || '{}') || {}; } catch (e) { return {}; } }
  function activeVehicle() { var api = window.FalcxVehicle; return api ? (api.getActive ? api.getActive() : api.getSaved && api.getSaved()) : null; }
  function isMine(v) { var api = window.FalcxVehicle; return !!(v && api && api.isMine && api.isMine(v)); }
  function vehicleName(v) { return v ? (isMine(v) ? 'your ' : '') + v.label : ''; }
  function summarize() { var f = window.FalcxFitment; return f && f.summarize ? f.summarize : null; }
  function fitRank(product, v) { var f = window.FalcxFitment; if (!v || !f) return 2; return f.rank(f.summarize(product, v)); }

  /* One product strip: cards hidden or shown for a guide group (index) or for the vehicle on show. */
  function applyStrip(strip, opts) {
    var grid = strip.querySelector('.fxg-shop__grid');
    if (!grid) return 0;
    var limit = Number(grid.dataset.fxgLimit) || 4;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-falcx-fitment="card"]'));
    cards.forEach(function (c, i) { if (!c.dataset.fxgI) c.dataset.fxgI = String(i); });
    var sum = summarize();
    var items = cards.map(function (card) {
      var product = parse(card);
      var index = Number(card.dataset.fxgI);
      var rank;
      if (opts.mode === 'vehicle') {
        rank = vehicleRank(product, opts.vehicle, sum, card.dataset.bodies);
      } else if (opts.vehicle && opts.keep) {
        /* Hub strips for the vehicle's own series: that series' parts, fitting ones first (the cards say what fits). */
        rank = productInGroup(product, groupOf(opts.vehicle.series)) ? fitRank(product, opts.vehicle) : null;
      } else if (opts.vehicle) {
        /* Article strips: leave out what is not listed for the vehicle; fitting parts first. */
        rank = sum && sum(product, opts.vehicle) === 'unlisted' ? null : fitRank(product, opts.vehicle);
      } else {
        rank = productInGroup(product, opts.group) ? 0 : null;
      }
      return { card: card, rank: rank, index: index };
    });
    var show = pick(items, limit);
    items.forEach(function (it) {
      var on = show.indexOf(it.index) !== -1;
      it.card.hidden = !on;
      it.card.style.display = on ? '' : 'none';
    });
    grid.setAttribute('data-fxg-ready', '');
    var none = strip.querySelector('[data-fxg-none]');
    if (none) none.hidden = show.length > 0;
    /* Say so when the vehicle left listed parts out. */
    var filtered = strip.querySelector('[data-fxg-filtered]');
    if (filtered) {
      var left = opts.vehicle && !opts.keep && opts.mode !== 'vehicle' && show.length > 0 && items.some(function (it) { return it.rank === null; });
      filtered.hidden = !left;
      var fname = filtered.querySelector('[data-fxg-filtered-name]');
      if (left && fname) fname.textContent = vehicleName(opts.vehicle);
    }
    grid.hidden = show.length === 0;
    return show.length;
  }

  /* ---------- Guides hub ---------- */
  var state = { group: '', chosen: false };
  function setGroup(root, group, fromVehicle) {
    state.group = group;
    root.querySelectorAll('[data-fxg-chip]').forEach(function (chip) {
      if (chip.closest('.fxg-chips')) chip.setAttribute('aria-pressed', String(chip.dataset.fxgChip === group));
    });
    var shown = 0;
    /* The filter names the vehicle's own series: strips put the parts that fit it first. */
    var v = activeVehicle();
    var opts = v && group && groupOf(v.series) === group ? { vehicle: v, keep: true } : { group: group };
    root.querySelectorAll('[data-fxg-group]').forEach(function (section) {
      var visible = 0;
      section.querySelectorAll('.fxg-grid [data-fxg-card]').forEach(function (card) {
        var on = articleInGroup(card.dataset.fxgSeries, group);
        card.hidden = !on;
        if (on) visible++;
      });
      shown += visible;
      var none = section.querySelector('[data-fxg-group-none]');
      if (none) {
        none.hidden = visible > 0;
        var name = none.querySelector('[data-fxg-series-name]');
        if (name) name.textContent = (LABELS[group] || 'this series') + ' Falcons';
      }
      section.querySelectorAll('[data-fxg-shop]').forEach(function (strip) { applyStrip(strip, opts); });
    });
    /* Keep the pressed chip in view in the phone's sideways chip row. */
    var pressedChip = root.querySelector('.fxg-chips [aria-pressed="true"]');
    var chipRow = pressedChip && pressedChip.parentNode;
    if (chipRow && chipRow.scrollWidth > chipRow.clientWidth) chipRow.scrollLeft = Math.max(0, pressedChip.getBoundingClientRect().left - chipRow.getBoundingClientRect().left + chipRow.scrollLeft - 16);
    var note = root.querySelector('[data-fxg-filter-note]');
    if (note) {
      note.hidden = !(fromVehicle && v && group);
      if (!note.hidden) note.textContent = 'Matched to ' + vehicleName(v) + '.';
    }
    return shown;
  }
  function renderVehicleRow(root) {
    var row = root.querySelector('[data-fxg-vehicle-row]');
    if (!row) return;
    var v = activeVehicle();
    if (!v) { row.hidden = true; return; }
    row.querySelectorAll('[data-fxg-vehicle-name]').forEach(function (el) { el.textContent = vehicleName(v); });
    var link = row.querySelector('[data-fxg-vehicle-link]');
    var api = window.FalcxVehicle;
    if (link && api && api.destination) link.setAttribute('href', api.destination(v));
    var strip = row.querySelector('[data-fxg-shop]');
    row.hidden = false;
    if (strip) applyStrip(strip, { mode: 'vehicle', vehicle: v });
  }
  function initIndex(root) {
    var filter = root.querySelector('[data-fxg-filter]');
    if (filter) filter.hidden = false;
    var v = activeVehicle();
    if (!state.chosen) setGroup(root, v ? groupOf(v.series) : '', !!v); else setGroup(root, state.group, false);
    renderVehicleRow(root);
    if (root.dataset.fxgBound) return;
    root.dataset.fxgBound = 'true';
    root.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-fxg-chip]');
      if (!chip || !root.contains(chip)) return;
      state.chosen = true;
      var count = setGroup(root, chip.dataset.fxgChip, false);
      var status = root.querySelector('[data-fxg-status]');
      if (status) status.textContent = count + (count === 1 ? ' guide' : ' guides') + ' for ' + (LABELS[chip.dataset.fxgChip] ? LABELS[chip.dataset.fxgChip] + ' Falcons' : 'every Falcon') + '.';
      if (!chip.closest('.fxg-chips')) {
        var pressed = root.querySelector('.fxg-chips [aria-pressed="true"]');
        if (pressed) pressed.focus();
      }
    });
  }

  /* ---------- Article ---------- */
  function initToc(article) {
    var toc = article.querySelector('[data-fx-toc]');
    if (!toc || toc.dataset.ready) return;
    var headings = article.querySelectorAll('[data-fx-article-body] h2');
    if (headings.length < 2) return;
    var taken = {};
    document.querySelectorAll('[id]').forEach(function (el) { taken[el.id] = true; });
    var ol = toc.querySelector('ol');
    headings.forEach(function (heading) {
      if (!heading.id) heading.id = slug(heading.textContent, taken);
      var item = document.createElement('li');
      var link = document.createElement('a');
      link.href = '#' + heading.id;
      link.textContent = heading.textContent.trim();
      item.append(link);
      ol.append(item);
    });
    toc.hidden = false;
    toc.dataset.ready = 'true';
    var wide = window.matchMedia ? window.matchMedia('(min-width: 990px)') : null;
    var sync = function () { toc.open = !!(wide && wide.matches); };
    sync();
    if (wide && wide.addEventListener) wide.addEventListener('change', sync);
    toc.addEventListener('click', function (e) { if (e.target.closest('a') && !(wide && wide.matches)) toc.open = false; });
  }
  /* Tables with a header row stack into labelled rows on phones (CSS .fxg-stack). */
  function initTables(article) {
    article.querySelectorAll('[data-fx-article-body] table').forEach(function (table) {
      if (table.dataset.fxgStack) return;
      var head = table.querySelector('thead tr') || (table.querySelector('tr th') ? table.querySelector('tr') : null);
      if (!head) return;
      var labels = Array.prototype.map.call(head.children, function (cell) { return cell.textContent.trim(); });
      if (labels.length < 2) return;
      table.querySelectorAll('tbody tr').forEach(function (row) {
        if (row === head) return;
        Array.prototype.forEach.call(row.children, function (cell, i) { if (labels[i]) cell.setAttribute('data-label', labels[i]); });
      });
      table.classList.add('fxg-stack');
      table.dataset.fxgStack = 'true';
    });
  }
  function initArticle(article) {
    initToc(article);
    initTables(article);
    var v = activeVehicle();
    article.querySelectorAll('.fxg-related [data-fxg-shop]').forEach(function (strip) { applyStrip(strip, { vehicle: v }); });
  }

  /* Notify forms inside <details>: open the one Shopify returned to (success or errors). */
  function openPostedForm() {
    var id = '';
    try { id = decodeURIComponent(window.location.hash.slice(1)); } catch (e) { return; }
    if (!id) return;
    var form = document.getElementById(id);
    var details = form && form.closest('details[data-fxg-notify]');
    if (details) details.open = true;
  }

  function init() {
    document.querySelectorAll('[data-fxg-index]').forEach(initIndex);
    document.querySelectorAll('[data-fx-article]').forEach(initArticle);
  }
  window.FalcxGuides = Object.assign({ init: init }, core);
  openPostedForm();
  init();
  document.addEventListener('falcx:vehicle-change', init);
  document.addEventListener('falcx:browsing-change', init);
  document.addEventListener('shopify:section:load', init);
})();
